import { inviteService } from "../services/inviteService";
import { useAsyncData } from "./useAsyncData";

export function useInvites(filters?: {
  search?: string;
  status?: string;
  role?: string;
  tenantId?: string;
}) {
  const key = JSON.stringify(filters ?? {});
  return useAsyncData(() => inviteService.listInvites(filters), [key]);
}
